import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { loginAdmin } from "../../core/services/authService";
import { useAuth } from "../../contexts/AuthContext";
import logo from "../../assets/images/logo.png";

const SignIn = () => {
  const [data, setData] = useState({ email: "", password: "" });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { setToken } = useAuth();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const result = await loginAdmin(data as any);

      if (result.success) {
        localStorage.setItem("adminProfile", JSON.stringify(result.admin));
        localStorage.setItem("adminToken", result.token);
        window.dispatchEvent(new Event("adminProfile:updated"));
        setToken(result.token);
        navigate("/dashboard");
        await Swal.fire({ title: "Login successful", icon: "success" });
      } else {
        Swal.fire({ title: result.message || "Login failed", icon: "error" });
      }
    } catch (error: any) {
      Swal.fire({ title: error.message || "Login failed", icon: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("adminToken")) {
      navigate("/dashboard");
    }
  }, [navigate]);

  return (
    <div className="signin-wrapper">
      <div className="signin-card">
        <div className="signin-logo">
          <img src={logo} alt="Sugam Store" />
        </div>
        <p className="signin-subtitle">Sign in to manage store operations</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="email"
              className="form-input"
              name="email"
              value={data.email}
              onChange={handleChange}
              required
            />
            <label className="form-label">Email Address</label>
          </div>

          <div className="form-group">
            <input
              type="password"
              className="form-input"
              name="password"
              value={data.password}
              onChange={handleChange}
              required
            />
            <label className="form-label">Password</label>
          </div>

          <button type="submit" className="signin-btn" disabled={isLoading}>
            {isLoading ? "Signing In..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SignIn;
